import axios from "axios";

const ShopifyGetProductVariant = async (id) => {
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_SHOPIFY_PROXY_URL}/api/graphql`,
      method: "POST",
      data: {
        query: `{
          productVariant(id: "gid://shopify/ProductVariant/${id}") {
            id
            title
            price
            image {
              url(transform: {maxHeight: 100})
            }
            product {
              id
              title
              productType
              featuredImage {
                url(transform: {maxHeight: 100})
              }
            }
          }
        }`,
      },
    });
    if (response.data.body.data.productVariant) {
      const { productVariant } = response.data.body.data;
      const image = productVariant.image
        ? productVariant.image.url
        : productVariant.product.featuredImage
        ? productVariant.product.featuredImage.url
        : "";
      return {
        ...productVariant,
        price: parseInt(productVariant.price),
        image,
      };
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default ShopifyGetProductVariant;
